<template>
    <div class="page-error-box">
        <el-image src="https://img01.ssrelease.com/0513/M00/CC/B1/ChAKCGVUjWOADLKmAAOA_SdWgwQ834.png"></el-image>
    </div>
</template>
<script>
export default {
    data(){
        return{
            
        }
    }
}
</script>
<style lang="scss" scoped>
.page-error-box{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 80vh;
    .el-image{
        width: 220px;
    }
}
</style>